<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mb-1" v-show="description && description != ''">
              <div class="col-12">
                <div
                    class="alert alert-warning mt-1 mb-1 alert-validation-msg"
                    role="alert"
                >
                  <div class="alert-body">
                    <span class="font-weight-bold">Description: {{description}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Status Updated By</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(row, index) in list">
                    <td>{{ index + 1 }}</td>
                    <td>{{ resolveStatusUpdatedBy(row) }}</td>
                    <td>{{ row.status_str }}</td>
                    <td>{{ row.comment }}</td>
                    <td>{{ new Date(row.created_at).toISOString().slice(0, 16).replace("T", " ") }}</td>
                  </tr>
                  </tbody>
                </table>
                <div class="col-12 text-center mb-25 text-primary" v-if="list.length == 0">No Data Avaliable</div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "data", "index","description"],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  methods:{
    resolveStatusUpdatedBy(row){
      if(!row.status_updated_by || row.status_updated_by == 0){
        return 'Auto Initiated'
      }
      if(row.updated_by){
        return row.updated_by.email + '/' + row.updated_by.first_name
      }

      return ''

    }
  },
  watch: {
    show() {
      this.list = this.data;
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

